import { ofType } from "redux-observable";
import { map } from "rxjs/operators";
import { actionGameTrackingUpdateShop } from "../../actionGameTracking";
import { TypeActionGameTrackingShopOpenSource, } from "../actionGameTrackingShop";
import { IdGameTrackingShopState } from "../IdGameTrackingShopState";
export var epicGameTrackingShopPackageSelect = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionGameTrackingShopOpenSource.PackageSelect), map(function (action) {
        return actionGameTrackingUpdateShop(IdGameTrackingShopState.SELECTED_GAME_PACKAGE, action.offerNameId);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/shop/epics/epicGameTrackingShopPackageSelect.ts
// module id = 1880
// module chunks = 3